import { render, staticRenderFns } from "./month-detail.vue?vue&type=template&id=18a687b3&"
import script from "./month-detail.vue?vue&type=script&lang=js&"
export * from "./month-detail.vue?vue&type=script&lang=js&"
import style0 from "./month-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports